import React from 'react';
import type { JsonObject } from '@/app-package';
import { FeedbackDoc } from '@bb/domain/dist/schemas';

const FeedbackView: React.FC<{
  feedback: JsonObject<Pick<FeedbackDoc, 'id' | 'template'>>;
}> = ({ feedback }) => (
    <div
      className="feedback-view"
      data-cy={`feedback-view-container-${feedback.id}`}
    >
      {feedback.template
        .map((question, i) => {
          if (!question.response) return null;
          return (
            <div
              className="feedback-view-item"
              key={i}
              data-cy={`feedback-question-item-${i}`}
            >
              {question.type !== 'checkbox' ? (
                <div>
                  <label
                    className="control-label"
                    data-cy={`feedback-question-${i}`}
                  >
                    {question.label}
                  </label>
                  <br />
                  <p data-cy={`feedback-response-${i}`}>{question.response}</p>
                </div>
              ) : (
                <div>
                  <label
                    className="control-label"
                    data-cy={`feedback-question-${i}`}
                  >
                    {question.label}
                  </label>
                  <br />
                  <ul data-cy={`feedback-response-${i}`}>
                    {question.response.split('  ').map((answer, j) => (
                      <li key={j} data-cy={`feedback-response-${i}-${j}`}>
                        {answer}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          );
        })
        .filter(Boolean)}
    </div>
  );

export default FeedbackView;
